import React from 'react';
import { Box } from '@chakra-ui/react';
import {
  GetPropsCommonOptions,
  UseSelectGetItemPropsOptions,
  UseSelectGetMenuPropsOptions,
} from 'downshift';

import SelectTypeVariant from './SelectItemVariant';
import SelectDropdown from './SelectDropdown';
import { SelectMeta, SelectOptions } from '../types';

interface SelectItemProps {
  option: SelectOptions;
  isOpen: boolean;
  forceGroupSelections: boolean;
  dark: boolean;

  isChecked?: boolean;
  groupMeta?: SelectMeta;
  parentKey?: string;

  getMenuProps: (
    options?: UseSelectGetMenuPropsOptions | undefined,
    otherOptions?: GetPropsCommonOptions | undefined,
  ) => any;
  getItemProps: (options: UseSelectGetItemPropsOptions<SelectOptions>) => any;
  onExpandableClick: (key: string) => void;
  onItemClick: (
    event: React.MouseEvent<HTMLElement> | React.ChangeEvent<HTMLElement>,
  ) => void;
}

const SelectItem = ({
  option,
  getItemProps,
  getMenuProps,
  parentKey,
  isOpen,
  groupMeta,
  onExpandableClick,
  onItemClick,
  forceGroupSelections,
  isChecked = false,
  dark,
}: SelectItemProps) => (
  <Box
    as="li"
    key={option.key}
    // @ts-ignore
    onClick={(event) => {
      event.stopPropagation();
      onExpandableClick(option.key);
    }}
    {...getItemProps}
    color={dark ? 'gray.100' : 'gray.700'}
    w="100%"
    mx={2}
  >
    <SelectTypeVariant
      type={option.children ? 'parent' : groupMeta?.type}
      onClick={(
        event: React.MouseEvent<HTMLElement> | React.ChangeEvent<HTMLElement>,
      ) => !option.children && onItemClick(event)}
      parentKey={parentKey}
      value={option.key}
      isChecked={isChecked}
      dark={dark}
      isOpen={isOpen}
    >
      {option.label}
    </SelectTypeVariant>
    {option.children && (
      <SelectDropdown
        dark={dark}
        getMenuProps={getMenuProps}
        data={option.children.options}
        isOpen={isOpen}
        getItemProps={getItemProps}
        meta={option.children.meta}
        parentKey={option.key}
        forceGroupSelections={forceGroupSelections}
      />
    )}
  </Box>
);

export default SelectItem;
